import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {getAutocompleteValue} from 'src/infrastructure/helper/autocomplete-helper';
import {SearchVendorResponse} from '../model/search-vendor-response';

@Injectable({
  providedIn: 'root'
})
export class VendorGridService implements GridGetService<SearchVendorResponse> {
  private readonly baseUrl = 'dbov2/vendor/search';
  private readonly http = inject(HttpClient);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<SearchVendorResponse>>  {

    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      vendorName: getAutocompleteValue(filters?.['vendorName']),
      vendorCity: getAutocompleteValue(filters?.['vendorCity']),
      vendorCountry: getAutocompleteValue(filters?.['vendorCountry']),
      dataSource: filters?.['dataSource']?.['id'] ?? filters?.['dataSource'] ?? '',
    };

    removeEmptyParams(params);
    
    return this.http.get<GridServiceResponse<SearchVendorResponse>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }
}